module.exports = __webpack_public_path__ + "assets/img/p_item_5.9306c6bb.png";